import { render, staticRenderFns } from "./TagProducts.vue?vue&type=template&id=24bd89a9&"
import script from "./TagProducts.vue?vue&type=script&lang=js&"
export * from "./TagProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports